// Author lidongxu
// Date 2023-12-04 15:15:22

import * as model from "@/model/sithMes/inventory/SithMesInventoryComprehensiveBusinessDetailModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesInventoryComprehensiveBusinessDetail(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_INVENTORY_URL,
    })
    .buildStore()
